import React from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import GymPlansStructure from "../../components/gym-plans/GymPlansStructure";

const GymPlans = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  return <GymPlansStructure userInfoData={userInfoData} />;
};

export default GymPlans;